import { useRef } from "react";
import "../assets/styles/Certificate.css";
import image from "../assets/image/Certficate.jpg";
import jsPDF from "jspdf";
import moment from "moment";
import CopyToClipboardCertificate from "../pages/Hire/CopyToClipboardCertificate";

const Certificate = ({ data, item }) => {
  const reportTemplateRef = useRef(null);

  const handleGeneratePdf = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      format: "a4",
      unit: "px",
    });

    doc.setFont("Arial");

    if (reportTemplateRef.current) {
      doc.html(reportTemplateRef.current, {
        callback: function (doc) {
          doc.save("certificate.pdf");
        },
        y: 7,
      });
    } else {
      doc.save("certificate.pdf");
    }
  };

  const formattedDate = moment(item?.Training?.endDate).format("DD-MM-YYYY");

  if (item?.Training?.trainingStatus === "COMPLETED") {
    return (
      <div className='certificate-div'>
        <div
          ref={reportTemplateRef}
          className='certificate'
          style={{ fontFamily: "Arial, sans-serif" }}
        >
          <div className='certificate-sub-div1'>
            <p className="certificate-name font-bold text-[22px]">
              {data?.firstName
                ? data?.firstName.charAt(0).toUpperCase() +
                data?.firstName.slice(1).toLowerCase()
                : ""}
              {` `}
              {data?.LastName
                ? data?.LastName.charAt(0).toUpperCase() +
                data?.LastName.slice(1).toLowerCase()
                : ""}
            </p>

            <p className='certificate-text'>has successfully completed</p>
            <p className='certificate-on'>
              Customer Service Professional Certification
            </p>
            <p className='certificate-text'>
              A customer service certification that offers a real-world environment
              to hone your skills.
            </p>
            <p className='certificate-text'>
              Date of completion: {formattedDate}
            </p>
          </div>
          <div className='certificate-sub-div2'>
            {/* <p>Verified at:</p>
            <a href='/' className='certificate-link'>
              http://training.outcess.com/verify/1234566
            </a> */}
            <p>Outcess has confirmed the identity of this individual and has</p>
            <p>participated in the course.</p>
          </div>
          <img className='certificate-image' src={image} alt='certificate' />
        </div>

        <div className="certificate_container">
          <button className='certificate-button' onClick={handleGeneratePdf}>
            Download Certificate
          </button>
          <CopyToClipboardCertificate id={data?.id} />
        </div>
      </div>
    );
  } else {
    return <p>Certificate is only available after completion of the training.</p>;
  }
};

export default Certificate;

